// extracted by mini-css-extract-plugin
export default {"linkList":"wy16VgM7lxSmgbYLBCuE","titleContainer":"s8eLMRdB7sFhvXJ1gBuM","linkItems":"wFnhE08tuyIuy30WqDCA"};